import { render } from "./repeatableGroupReadOnly.vue?vue&type=template&id=32f85b3e"
import script from "./repeatableGroupReadOnly.vue?vue&type=script&lang=js"
export * from "./repeatableGroupReadOnly.vue?vue&type=script&lang=js"

import "./repeatableGroupReadOnly.vue?vue&type=style&index=0&id=32f85b3e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__